import { render, staticRenderFns } from "./list.vue?vue&type=template&id=0ee3124a&scoped=true"
import script from "./list.vue?vue&type=script&setup=true&lang=js"
export * from "./list.vue?vue&type=script&setup=true&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=0ee3124a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee3124a",
  null
  
)

export default component.exports